let chatwootActiveOnSupportPage = false;
let chatwootWindowOpen = false;

const shouldShowChatwootBubble = () => chatwootActiveOnSupportPage || chatwootWindowOpen;

const setChatwootBubbleVisibility = visible => {
  if (window.$chatwoot && typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
    window.$chatwoot.toggleBubbleVisibility(visible ? 'show' : 'hide');
  }
};

export const applyChatwootBubbleVisibility = () => setChatwootBubbleVisibility(shouldShowChatwootBubble());

export const activateChatwootSupportPage = () => {
  chatwootActiveOnSupportPage = true;
  applyChatwootBubbleVisibility();
};

export const deactivateChatwootSupportPage = () => {
  chatwootActiveOnSupportPage = false;
  applyChatwootBubbleVisibility();
};

export const markChatwootOpen = () => {
  chatwootWindowOpen = true;
  applyChatwootBubbleVisibility();
};

export const markChatwootClosed = () => {
  chatwootWindowOpen = false;
  applyChatwootBubbleVisibility();
};

const resetChatwootSession = () => {
  chatwootActiveOnSupportPage = false;
  chatwootWindowOpen = false;
  if (window.$chatwoot && typeof window.$chatwoot.reset === 'function') {
    window.$chatwoot.reset();
  }
};

export default resetChatwootSession;
